import * as React from 'react';

import NotFound from 'components/not-found/NotFound';

import Page from '../Page';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./page-not-found.i18m.json'));

type Props = {};

class PageNotFound extends React.PureComponent<Props> {
  render(): React.ReactNode {
    return (
      <Page
        documentTitle={__t('page_not_found.text')}
      >
        <NotFound />
      </Page>
    );
  }
}

export default PageNotFound;
